export default __webpack_public_path__ + "static/media/step_01.a48ea8b1.svg";